export const layoutSiderInjectionKey = Symbol('layoutSiderInjection');
export const positionProp = {
    type: String,
    default: 'static'
};
